<template>
  <div id="app">
    <pc-header-menu v-if="this.$isPC" />
    <sp-header-menu v-else />
    <router-view id="wrapper" :class="this.$isPC ? '' : 'sp-wrapper-margin'" />
    <footer-menu />
  </div>
</template>

<script>
import Vue from 'vue'
import vueSmoothScroll from 'vue-smooth-scroll'
import PcHeaderMenu from '@/components/modules/PcHeaderMenu'
import SpHeaderMenu from '@/components/modules/SpHeaderMenu'
import FooterMenu from '@/components/modules/FooterMenu'
import LinkButton from '@/components/modules/LinkButton'
import { Slide } from 'vue-burger-menu'

Vue.use(vueSmoothScroll)
Vue.component('link-button', LinkButton)
Vue.component('slide', Slide)

Vue.prototype.$isPC = screen.width >= 1100

Vue.filter('toLocaleString', function(value) {
  return value.toLocaleString()
})

export default {
  name: 'App',
  components: {
    PcHeaderMenu,
    SpHeaderMenu,
    FooterMenu,
  },
}
</script>

<style>
body {
  margin: auto;
}

#app {
  font-family: 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', '游ゴシック体',
    'メイリオ', Meiryo, 'Yu Gothic', YuGothic, 'Oswald', 'ＭＳ Ｐゴシック',
    sans-serif;

  color: #4d4d4d;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app :lang(en) {
  font-family: Arial, Helvetica, 'sans-serif';
}

#wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;

  width: auto;
}

.sp-wrapper-margin {
  margin-top: 96px;
}

/* 汎用テーブル */
.common-table {
  font-size: 14px;

  display: flex;
  justify-content: center;

  width: 100%;

  border-collapse: collapse;
}

.common-table th {
  font-weight: normal;

  width: 200px;
  padding: 5px;

  text-align: center;

  border: 1px solid rgb(208, 209, 210);
  background-color: rgb(238, 244, 249);
}

.common-table td {
  width: 700px;
  padding: 10px 20px 10px;

  text-align: left;

  border: 1px solid rgb(208, 209, 210);
}

/* 商品タイプの表示 */
.product-type {
  display: flex;
}

.product-type section {
  flex-basis: 100%;
  flex-grow: 1;

  padding: 0;
}

.product-items {
  width: 450px;
  margin: 0;
  padding: 10px 0 10px;

  list-style: none;
}

.product-items li + li {
  margin-top: 10px;
}

.for-outgoing,
.for-incoming {
  padding: 2%;
}

.product-header {
  font-weight: bold;

  display: inline-block;

  width: 90%;
  padding: 10px 5%;

  text-align: center;
}

.product-header .header-bold {
  font-size: 30px;
}

.product-items li {
  text-align: left;
}

.product-items li .summary-appeal {
  margin: 10px 0;

  white-space: pre-line;
}

.product-items li .summary-detail {
  margin-bottom: 10px;

  white-space: pre-line;
}

/* for-outgoing */
.for-outgoing {
  margin: 0 10px 0 0;

  background-color: rgb(232, 248, 237);
}

.for-outgoing .product-header {
  float: right;

  /* padding-right: 100px;
  padding-left: 50%; */

  background-color: rgb(190, 234, 203);
}

.for-outgoing .product-header .header-bold {
  color: rgb(45, 183, 68);
}

.for-outgoing .product-items {
  float: right;

  padding-right: 25px;
  padding-left: 15px;
}

.for-outgoing .product-items li .summary-appeal {
  color: rgb(45, 183, 68);
}

.for-outgoing .product-items li .summary-footer a {
  color: rgb(45, 183, 68);
  border: 1px solid rgb(45, 183, 68);
  background-color: rgb(248, 252, 249);
}

/* for-incoming */
.for-incoming {
  background: rgb(233, 245, 255);
}

.for-incoming .product-header {
  float: left;

  /* padding-right: 50%;
  padding-left: 100px; */

  background-color: rgb(167, 214, 253);
}

.for-incoming .product-header .header-bold {
  color: rgb(16, 106, 203);
}

.for-incoming .product-items {
  float: left;

  padding-right: 15px;
  padding-left: 25px;
}

.for-incoming .product-items li .summary-appeal {
  color: rgb(16, 106, 203);
}

.for-incoming .product-items li .summary-footer a {
  color: rgb(16, 106, 203);
  border: 1px solid rgb(16, 106, 203);
  background-color: rgb(248, 251, 255);
}

/* 汎用リンクボタン */
.link-button {
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;

  float: right;

  min-width: 120px;
  padding: 5px;

  text-align: center;
  text-decoration: none;

  color: white;
  border-radius: 3px;
  background-color: rgb(26, 87, 167);
}

/* サークルヘッダー */
.circle-parent {
  position: relative;

  width: auto;
  height: 60px;
}

.circle-heading {
  position: relative;
  z-index: 1;

  display: inline-block;

  width: 150px;
  height: 150px;

  border-radius: 50%;
  background: rgb(26, 87, 167);
}

.circle-heading.green {
  background: rgb(45, 183, 68);
}

.circle-heading-title {
  font-size: 18px;
  font-weight: bold;

  position: absolute;
  top: 50%;
  left: 0;

  width: 100%;

  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;

  color: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue